// extracted by mini-css-extract-plugin
var _1 = "RecoverPasswordFormFields-modulebutton__Eluf5";
var _2 = "RecoverPasswordFormFields-moduleformFields__dNwnQ FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
export { _1 as "button", _2 as "formFields" }
